export default __webpack_public_path__ + "6e1690e71219d551cc574213c92ec85d.svg";